export const NEW_ITEM_ID_URL = 'new';
export const EDIT_PATH = 'edit';
